/* jshint esversion: 6 */

class MdcDotCampaign {
  static renderProgressChart($container, label, progress, color) {
    let options = {
      chart: {
        height: '120%',
        type: "radialBar"
      },
      xaxis: {
        crosshairs: false// Disable the x-axis crosshairs
      },
      yaxis: {
        crosshairs: false// Disable the x-axis crosshairs
      },
      grid: {
        show: false
      },

      series: [isNaN(progress) ? 0 : progress],
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 2000,  // Animation speed in milliseconds
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: "70%",
            background: "#fff"
          },
          track: {
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              blur: 4,
              opacity: 0.15
            }
          },
          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -10,
              show: true,
              color: "#000",
              fontSize: "0.75rem"
            },
            value: {
              offsetY: 2,
              color: "#111",
              fontSize: "1.5rem",
              show: true
            }
          }
        }
      },
      fill: {
        colors: [color]
      },
      stroke: {
        lineCap: "round",
      },
      labels: [label]
    };

    window['apexCharts'] = window['apexCharts'] || [];
    let chart = new ApexCharts($container, options);
    window['apexCharts'].push(chart);
    chart.render();
  }

  static renderPieChart($container, calculations, key) {
    let options;

    let pieLabel;
    if (key === 'emailsSent') pieLabel = 'Emails Sent';
    if (key === 'leadsAdded') pieLabel = 'Leads Added';

    options = {
      legend: {show: false},
      series: calculations.map(item => item.value),

      chart: {
        height: '120%',
        type: 'donut',
        dropShadow: {
          enabled: true,
          color: '#111',
          top: -1,
          left: 3,
          blur: 3,
          opacity: 0.2
        }
      },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          donut: {
            size: '90%',
            labels: {
              show: true,
              total: {
                label: pieLabel,  // Set the static label for the total
                showAlways: true,
                show: true
              },
              name: {
                offsetY: -10,
                show: true,
                color: "#000",
                fontSize: "0.75rem"
              },
              value: {
                offsetY: 2,
                color: "#111",
                fontSize: "1.5rem",
                show: true
              }
            }
          }
        }
      },
      labels: calculations.map(item => item.name),
      dataLabels: {
        enabled: false,
        formatter: function (val, opts) {
          const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
          const percentage = ((val / total) * 100).toFixed(2);// Calculate percentage
          return percentage + '%';  // Display percentage on hover
        },
      },

      tooltip: {
        enabled: true,
        custom: function ({series, seriesIndex, w}) {
          const total = series.reduce((a, b) => a + b, 0);  // Calculate total
          const value = series[seriesIndex];  // Get current slice value
          const percentage = ((value / total) * 100).toFixed(2);  // Calculate percentage
          const label = w.globals.labels[seriesIndex];  // Get series name
          const color = w.globals.colors[seriesIndex];  // Get corresponding slice color

          // Return the custom tooltip HTML with dynamic background color
          return `
        <div style="background-color: ${color}; color: white; padding: 10px; 
                    border-radius: 8px; text-align: center;">
          <strong>${label}</strong><br>
          ${value} ${pieLabel} <br>
          Percentage: ${percentage}%
        </div>`;
        }
      },

      states: {
        hover: {
          filter: 'none'
        }
      },
      theme: {
        palette: 'palette2'
      }
    };

    window['apexCharts'] = window['apexCharts'] || [];
    let chart = new ApexCharts($container, options);
    window['apexCharts'].push(chart);
    chart.render();
  }

  static destroyProgressCharts() {
    _.each(window['apexCharts'], function (apexChart) {
      // Destroy the current chart
      apexChart.destroy();
    })
  }

  static renderChart(data) {
    const chartDom = document.getElementById('chart');
    let option;

    const existingChart = echarts.getInstanceByDom(chartDom);
    if (existingChart) {
      existingChart.dispose();
    }

    const myChart = echarts.init(chartDom);

    option = {
      legend: {
        show: false,
        top: 'bottom'
      },
      toolbox: {
        show: false,
        feature: {
          // mark: {show: true},
          // dataView: {show: true, readOnly: false},
          // restore: {show: true},
          // saveAsImage: {show: true}
        }
      },
      series: [
        {
          name: 'Stats Chart',
          type: 'pie',
          radius: [25, 100],
          center: ['50%', '50%'],
          roseType: 'area',
          itemStyle: {
            borderRadius: 4
          },
          label: {
            formatter: function (params) {
              if (params.data.percentage) {
                return `${params.name}\n ${params.value}\n(${params.data.percentage})`;
              } else {
                return `${params.name}\n ${params.value}`;
              }
            }
          },
          data: data,
          // Custom color palette
          color: ['#87C654', '#000000', '#00b4ff', '#6092ce', '#7e75b8', '#bb3a8e', '#d91d78', '#f70063']
        },
      ]
    };
    option && myChart.setOption(option);

    const observeResize = new ResizeObserver(entries => {
      myChart.resize();
    });
    observeResize.observe(chartDom);
  }

  static campaignDataLastUpdatedOn = function (value) {
    const app = PreBuilt;
    const userTimeZone = app.apis['user'].get().timezone;
    const key = $('[data-item="campaignDataLastUpdatedOn"]');
    if (!app.isEmpty(value)) {
      const lastUpdated = moment(value).tz(userTimeZone).format('YYYY-MM-DD HH:mm:ss z');
      key.text(`Last updated : ${lastUpdated}`);
    }
  }

  static getHeaderColumn($container) {
    Responsive.getCalendarColumn($container.parent(), $container, 250, 200, 4);
  }

  static animateNumber($container, finalNumber, duration) {
    let currentNumber = 0;

    // Calculate the total number of increments (set to run every 30ms)
    const intervalTime = 45; // Time between updates (in milliseconds)
    const totalIncrements = Math.ceil(duration / intervalTime); // Total number of updates
    const incrementValue = Math.ceil(finalNumber / totalIncrements); // Value to increment each time

    const timer = setInterval(() => {
      currentNumber += incrementValue;

      // Ensure it doesn't overshoot the final number
      if (currentNumber >= finalNumber) {
        currentNumber = finalNumber;
        clearInterval(timer);
      }

      // Update the div with the current number
      $container.text(currentNumber);
    }, intervalTime);
  }

  static animatePercentage() {
    //document.querySelector(`.stat-percentage[data-id="${key}"]`).style.setProperty("--percent", stat.ratePercentage);
  }

  static calculateEmailMetrics(row) {

    // Calculate percentages
    const deliveryRate = (row.delivered / row.emailsSent) * 100;  // Delivery Rate (%)
    const openRate = (row.open / row.delivered) * 100;          // Open Rate (%)
    const clickRate = (row.click / row.delivered) * 100;        // Click Rate (%)
    const bounceRate = (row.bounce / row.emailsSent) * 100;      // Bounce Rate (%)
    const unsubscribeRate = (row.unsubscribe / row.emailsSent) * 100; // Unsubscribe Rate (%)
    const spamRate = (row.spamReport / row.emailsSent) * 100;    // Spam Rate (%)

    return {
      deliveredRate: !isNaN(deliveryRate) ? deliveryRate.toFixed(2) + '%' : '',
      openRate: !isNaN(openRate) ? openRate.toFixed(2) + '%' : '',
      clickRate: !isNaN(clickRate) ? clickRate.toFixed(2) + '%' : '',
      bounceRate: !isNaN(bounceRate) ? bounceRate.toFixed(2) + '%' : '',
      unsubscribeRate: !isNaN(unsubscribeRate) ? unsubscribeRate.toFixed(2) + '%' : '',
      spamReportRate: !isNaN(spamRate) ? spamRate.toFixed(2) + '%' : ''
    };
  }

  static types() {

    return [
      {id: 'leadsAdded', name: 'Leads Added', info: ''},
      {id: 'emailsSent', name: 'Emails Sent', info: ''},
      {
        id: 'delivered',
        name: 'Delivered',
        info: 'An email delivered status means that the email was successfully sent and accepted by the recipient\'s email server. However, it doesn\'t necessarily mean that the email was delivered to the recipient\'s inbox. The recipient\'s email provider may have filtered the email into spam or discarded it altogether.'
      },
      {
        id: 'open',
        name: 'Unique Opens',
        info: 'Email unique opens is a metric that measures the number of unique recipients who opened an email at least once. It\'s calculated by dividing the total number of unique recipient email opens by the number of emails delivered in the campaign.'
      },
      {
        id: 'click',
        name: 'Unique Clicks',
        info: 'In email marketing, unique clicks is a metric that counts the number of unique recipients who clicked on at least one link in an email.'
      },
      {
        id: 'bounce',
        name: 'Bounces',
        info: 'An email bounce rate is the percentage of emails that are not delivered to a recipient\'s inbox and are returned to the sender. This stat can include various rejection types from blocks, bounces, reputation, or bad email addresses.'
      },
      {
        id: 'unsubscribe',
        name: 'Unsubscribes',
        info: 'An email unsubscribe rate is the percentage of email subscribers who opt out of receiving emails from a company or brand. It\'s calculated by dividing the number of unsubscribed users by the number of emails sent, and then multiplying by 100.'
      },
      {
        id: 'spamReport',
        name: 'Marked Spam',
        info: 'The percentage of emails delivered that are marked as spam. A low spam rate is important because spam complaints can harm your sender reputation and spam score. This rate does not include spam reports from Gmail as they do not provide them.'
      },

    ];
  }

  static updateStatsHeader = function (allTotals) {
    const app = PreBuilt;
    const totals = Object.fromEntries(
        Object.entries(allTotals).map(([key, value]) => [key, value.total])
    );

    console.log(totals);

    const metrics = MdcDotCampaign.calculateEmailMetrics(totals);
    let mappedStats = {};

    delete totals.processed;
    delete totals.deferred;

    MdcDotCampaign.destroyProgressCharts();

    let chartColors = ['#00b4ff', '#6092ce', '#7e75b8', '#bb3a8e', '#d91d78', '#f70063'];

    _.each(totals, function (stat, key) {
      let row = {};
      row.key = key;
      row.value = stat;
      row.rate = metrics[key + 'Rate'] || null; // Use || null to set null if key doesn't exist

      if (!app.isEmpty(row.rate)) {
        row.ratePercentage = parseFloat(row.rate.replace('%', '')) / 100;
      }
      mappedStats[key] = row;
    });

    _.each(mappedStats, function (stat, key) {
      const $name = $(`.stat-name[data-id="${key}"]`);
      $name.closest('.card-body').removeClass('m-progress');
      if (key === 'emailsSent' || key === 'leadsAdded') {
        const $value = $(`.stat-value[data-id="${key}"]`);
        const $percentage = $(`.stat-percentage[data-id="${key}"]`);
        const $chart = $(`.stat-chart[data-id="${key}"]`);

        $name.remove();
        $percentage.remove();

        $value.text(stat.value);
        //$value.removeClass('percentage-animation');
        //$value.removeClass('text-animation');
        //MdcDotCampaign.animateNumber($value, stat.value, 3000);

        MdcDotCampaign.renderPieChart($chart[0], allTotals[key]['calculations'], key);

      } else {

        const $value = $(`.stat-value[data-id="${key}"]`);
        const $percentage = $(`.stat-percentage[data-id="${key}"]`);
        const $chart = $(`.stat-chart[data-id="${key}"]`);

        $name.remove();
        $percentage.remove();

        $value.text(stat.value);
        const progress = (stat.ratePercentage * 100).toFixed(2);
        MdcDotCampaign.renderProgressChart($chart[0], MdcDotCampaign.types().find(item => item.id === stat.key)['name'], progress, chartColors.shift());
      }
    });

    let data = [];
    _.each(MdcDotCampaign.types(), function (type) {
      const percentage = mappedStats[type.id] ? mappedStats[type.id]['rate'] : null;
      const row = {'name': type.name, 'value': totals[type.id], 'percentage': percentage}
      data.push(row);
    });

    $('.campaign-chart-element').closest('.card-body').removeClass('m-progress');

    this.renderChart(data);
  }

  static updateCampaginGroupsCount(data) {

    const $groups = $('[data-camapaign-groups]');
    _.each($groups, function (group) {
      const $group = $(group);
      const key = $group.attr('data-item');
      if (data[key]) {
        $group.text(data[key].length);
      }
    })
  }

  static statsHeaderLoader() {
    const app = PreBuilt;

    this.destroyProgressCharts();

    const $headerContainer = $('[data-campaign-header]');
    $headerContainer.empty();

    _.each(MdcDotCampaign.types(), function (type) {
      const metrics = _.template(app.templates['dot_campaign__header-col']);
      const $metrics = $(metrics(type));
      $metrics.appendTo($headerContainer);
    });

  }
}


class CampaignFilter {

  static async filterCallback(response) {
    const app = PreBuilt;

    let range = response.range;
    if (!app.isEmpty(range)) {
      range = range.split(' - ');
      range = range.map(date => date.trim());
      if (!app.isEmpty(range[0])) {
        response.range = range;
      } else {
        delete response.range;
      }
    }

    NoRecordsPlaceholder.destroy();
    Toast.destroy();
    if (!app.isEmpty(app.filterModal)) {
      app.filterModal.modal('hide');
    }

    let message = [];
    const messageStatic = `Showing results for filters with `;

    if (!app.isEmpty(response.campaigns)) {
      const campaigns = response.campaigns.join(',')
      message.push(` <span class="fw-semibold"> ${campaigns}</span>`)
    }

    if (!app.isEmpty(response.q)) {
      const q = response.q;
      message.push(` <span class="fw-semibold">search ${q}</span>`)
    }

    if (!app.isEmpty(range)) {
      message.push(`<span class="fw-semibold"> date range ${range[0]} to ${range[1]} </span>`);
    }
    message = messageStatic + message.join(' and ');

    response.filter = true;
    window['searchParams'] = response;

    const $listContainer = $('[data-campaigns]');
    const listManager = new CampaignsList(app, $listContainer, 'dot_campaign__row');
    listManager.onRenderList().then(function (leadResponse) {

    });

    app.Toast = new Toast(app, $listContainer.closest('.table-campaigns'), {
      'toastClass': 'mb-5 position-sticky top-0',
      'message': message, closeButton: {
        text: 'Clear Filter',
        onClick: () => {
          Toast.destroy();
          window['searchParams'] = null;
          const listManager = new CampaignsList(app, $listContainer, 'dot_campaign__row');
          listManager.onRenderList().then(function (leadResponse) {

          });
        }
      }
    });
    app.Toast.render();
  }

  async filter() {
    const app = PreBuilt;
    const options = {
      modalDialogClass: 'modal-xl  modal-dialog-scrollable modal-dialog-centered  modal-filter-campaigns',
      template: 'dot_campaign__filter',
      title: 'Filter Campaign (Email) Statistics ',
      saveButtonText: 'Filter',
      footerText: 'Filter email statistics by date range and  campaigns',
      saveApi: '',
      saveApiCallBack: 'CampaignFilter.filterCallback',
    };

    app.inputPrompt(options).then(async function ($modal) {
      app.filterModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();

      const $select = $modal.find(':input[name="campaigns[]"]');

      let url = '/api/mdcdot/campaigns';
      const response = await app.apis['mdcdot'].campaign.list(url);
      const campaigns = Object.values(response.result).reverse();
      $select.closest('.campaigns-row-container').removeClass('m-progress');
      $select.attr('multiple', 'multiple');
      // Loop through the campaignsIndexById and create an option for each
      _.each(campaigns, function (campaign) {
        const $optGroup = $('<optgroup></optgroup>');
        $optGroup.attr('label', campaign.name);
        $optGroup.appendTo($select);

        const $option = $('<option></option>');
        $option.text(`Campaign - ${campaign.name}`);
        $option.attr('value', `campaign:${campaign.id}`);
        $option.appendTo($optGroup);
        _.each(campaign.sequences, function (sequence) {
          const $option = $('<option></option>');
          $option.text(`Sequence - ${sequence.name}`);
          $option.attr('value', `sequence:${sequence.id}`);
          $option.appendTo($optGroup);
        })
      });

      $select.select2({
        dropdownCssClass: 'tags-select2-dropdown',
        selectionCssClass: 'tags-select2-selection'
      });


      const $input = $modal.find('input[name=range]');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 3,
        grid: 3,
        plugins: [
          "RangePlugin",
          "LockPlugin",
          "PresetPlugin"
        ],
        PresetPlugin: {
          customLabels: ['Today', 'Yesterday', 'Last 7 Days', 'Last 30 Days', 'This Month', 'Last Month'],
          presets: [
            {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()}, // 'Last 7 Days'
            {start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date()}, // 'Last 30 Days'
            {start: new Date(new Date().getFullYear(), new Date().getMonth(), 1), end: new Date()}, // 'This Month'
            {
              start: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
              end: new Date(new Date().getFullYear(), new Date().getMonth(), 0)
            }, // 'Last Month'
          ].map((preset, index) => {
            // console.log(`Preset ${index}: Start = ${preset.start}, End = ${preset.end}`);

            // Check if start and end dates are valid instances of Date
            if (!(preset.start instanceof Date) || isNaN(preset.start.getTime())) {
              console.error(`Invalid start date for preset ${index}`);
              preset.start = new Date(); // Default to current date if invalid
            }
            if (!(preset.end instanceof Date) || isNaN(preset.end.getTime())) {
              console.error(`Invalid end date for preset ${index}`);
              preset.end = new Date(); // Default to current date if invalid
            }

            return preset;
          }),
          position: 'right',
        },
        LockPlugin: {
          minDays: 0,
          maxDays: 90,
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

      progress.remove();
    });
  }
}

class CampaignsList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow, sortBy, sortByDirection) {
    super(app, container, listRow, false);
    if (!app.isEmpty(sortBy)) {
      this.sortBy = sortBy;
    } else {
      this.sortBy = 'id';
    }

    if (!app.isEmpty(sortByDirection)) {
      this.sortByDirection = sortByDirection;
    } else {
      this.sortByDirection = 'DESC';
    }

    const status = Utils.getQueryParam('status');

    this.searchParams = !app.isEmpty(window['searchParams']) ? window['searchParams'] : null;

    if(!app.isEmpty(status)) {
      if(!app.isEmpty(this.searchParams)) {
        this.searchParams = {'status' : status};
      } else {
        this.searchParams = {...this.searchParams, ...{'status' : status}};
      }

    }
    if (!app.isEmpty(this.searchParams)) {
      aimi_mdcdot_campaign.list.buttons().disableRefresh();
    } else {
      aimi_mdcdot_campaign.list.buttons().enableRefresh();
    }

    this.container.empty();
    this.paginator = new Paginator(1000);
    this.renderList = this.renderList.bind(this);
    this.paginatedUrl = new PaginatedUrl(`/api/mdcdot/campaigns`, 1, 1000);

    this.renderList(1);
  }

  prepareRow(row) {
    const statsDefault = {
      leadsAdded: this.staticPH,
      emailsSent: this.staticPH,
      delivered: this.staticPH,
      open: this.staticPH,
      click: this.staticPH,
      bounce: this.staticPH,
      unsubscribe: this.staticPH,
      spamReport: this.staticPH,
      deliveredRate: this.staticPH,
      openRate: this.staticPH,
      clickRate: this.staticPH,
      bounceRate: this.staticPH,
      unsubscribeRate: this.staticPH,
      spamReportRate: this.staticPH
    };

    row.metrics = _.template(this.app.templates['dot_campaign__partial-metrics']);
    row.metrics = row.metrics(
        {
          ...statsDefault,
          ...row,
          ...MdcDotCampaign.calculateEmailMetrics(row),
        }
    );

    const page = _.template(this.app.templates[this.listRow]);

    let pageData = {
      ...row,
    };

    const $page = $(page(pageData));

    return $page;
  }

  loaderData = {
    id: null,
    leftPadding: '',
    rowType: '',
    campaignId: null,
    firstSequence : {status : false},
    name: this.staticPH,
    leadsAdded: this.staticPH,
    emailsSent: this.staticPH,
    delivered: this.staticPH,
    open: this.staticPH,
    click: this.staticPH,
    bounce: this.staticPH,
    unsubscribe: this.staticPH,
    spamReport: this.staticPH,
    deliveredRate: this.staticPH,
    openRate: this.staticPH,
    clickRate: this.staticPH,
    bounceRate: this.staticPH,
    unsubscribeRate: this.staticPH,
    spamReportRate: this.staticPH
  }

  processedLoaderData(overrideData = {}) {
    let data = this.loaderData;
    data.metrics = _.template(this.app.templates['dot_campaign__partial-metrics']);
    data.metrics = data.metrics(data);

    data = {...data, ...overrideData};
    return data;
  }

  updateCampaignData(campaignData, data = {}) {
    const self = this;
    if (this.app.isEmpty(data)) {
      const campaignRow = $(`.campaign-row[data-row=${campaignData.id}]`);
      let loaderData = {
        leftPadding: '',
        rowType: 'campaign',
        id: campaignData.id,
        campaignId: campaignData.id,
        name: campaignData.name
      };
      const $row = self.getLoaderRow(self.processedLoaderData(loaderData));
      campaignRow.replaceWith($row);

      _.each(campaignData.sequences, function (sequence) {
        const sequenceRow = $(`.sequence-row[data-row=${sequence.id}]`);
        let loaderData = {
          leftPadding: 'ps-8',
          rowType: 'sequence',
          id: sequence.id,
          campaignId: sequence.campaignId,
          name: sequence.name
        };
        const $row = self.getLoaderRow(self.processedLoaderData(loaderData));
        sequenceRow.replaceWith($row);
      });
    } else {
      MdcDotCampaign.campaignDataLastUpdatedOn(data.campaignDataLastUpdatedOn);

      _.each(data, function (campaign, key) {

        if (window.campaignsIndexById[key]) {
          const row = campaign.campaignData;

          row.leftPadding = '';
          row.rowType = 'campaign';
          row.campaignId = row.id;

          self.clearLoader($(`[data-campaign=${row.id}]`));

          const campaignRow = $(`.campaign-row[data-row=${row.id}]`);
          const $row = self.prepareRow(row);
          campaignRow.replaceWith($row);

          _.each(campaign.sequencesData, function (sequence) {
            sequence.leftPadding = 'ps-8';
            sequence.rowType = 'sequence';
            sequence.campaignId = sequence.dotCampaignId;

            const sequenceRow = $(`.sequence-row[data-row=${sequence.id}]`);
            const $row = self.prepareRow(sequence);
            sequenceRow.replaceWith($row);
          });
        }

      })

    }
  }

  async fetchCampaignStat(campaign) {

    // Simulating an API call
    await this.updateCampaignData(campaign, false);
    const searchParams = !this.app.isEmpty(window['searchParams']) ? window['searchParams'] : null;

    let response;
    if (this.app.isEmpty(searchParams)) {

    } else {
      //  response = await this.app.apis['mdcdot']['campaign'].searchStats(campaign.id, searchParams);
    }

    response = await this.app.apis['mdcdot']['campaign'].refresh(campaign.id, searchParams);
    await this.updateCampaignData(campaign, response);
    return await response; // Assuming the response is in JSON format
  }

  async fetchCampaignStatsSequentially(campaignIds = [], searchFilter = false) {
    // Get the array of values from the object
    let rows = Object.values(window.campaignsIndexById).reverse();
    let response;

    if (!this.app.isEmpty(campaignIds)) {
      rows = rows.filter(campaign => campaignIds.includes(campaign.id));
    }

    for (const row of rows) {
      // Await each fetchData call, ensuring they are executed one after another
      response = await this.fetchCampaignStat(row);
    }

    const $listContainer = $('[data-campaigns]');
    $listContainer.empty();

    // Update whole page
    this.renderList(1);
  }

  async renderList(page) {
    const self = this;
    const $listContainer = this.container
    const $parentContainer = $('.campaigns-container');
    let campaigns = [];
    this.isRendering = true;

    if (this.app.isEmpty(window.campaignsIndexById)) {
      window.campaignsIndexById = {};
    }

    try {
      if (page) {

        if (this.lazyloader) {
          this.lazyloader.destroy();
        }

        this.showLoader(this.processedLoaderData());
        MdcDotCampaign.statsHeaderLoader();

        $parentContainer.find('.btn-sort').attr('disabled', 'disabled');

        const $pageTitle = $('[data-count-all-campaigns]');
        $pageTitle.addClass('animated flash');
        const response = await this.app.apis['mdcdot'].campaign.list(this.paginatedUrl.getPageUrl(page), this.sortBy, this.sortByDirection, this.searchParams);
        this.apiResponse = response;

        if (response.campaignDataLastUpdatedOn) {
          MdcDotCampaign.campaignDataLastUpdatedOn(response.campaignDataLastUpdatedOn);
        }

        if (response.totals) {
          MdcDotCampaign.updateStatsHeader(response.totals, response.result);
        }


        $pageTitle.removeClass('animated flash');
        $pageTitle.text(`(${response.total})`);
        $pageTitle.data('count-all-campaigns', response.total)
        $('.rows-selector-wrapper').find('button[data-campaign-action]').removeAttr('disabled');
        $parentContainer.find('.btn-sort').removeAttr('disabled');

        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);

        campaigns = this.paginator.getCurrentPage();
      } else {
        campaigns = this.paginator.getNextPage();
      }

      this.removeLoader();

      if (!this.app.isEmpty(campaigns)) {
        _.each(campaigns, function (row) {

          window.campaignsIndexById[row.id] = row;
          row.leftPadding = '';
          row.campaignId = row.id;
          row.rowType = 'campaign';
          let $row = self.prepareRow(row);
          $row.appendTo($listContainer);

          _.each(row.sequences, function (sequence) {
            sequence.leftPadding = 'ps-8';
            sequence.rowType = 'sequence';
            sequence.campaignId = sequence.dotCampaignId;
            let $row = self.prepareRow(sequence);
            $row.appendTo($listContainer);
          });
        });

        this.app.initTooltip();

        if (this.apiResponse.callDotCampaignData) {
          await this.fetchCampaignStatsSequentially(this.apiResponse.campaignIds, this.apiResponse.searchFilter);
        }

        this.isRendering = false;

        let hasMoreData = this.paginator.hasMoreData();
        return hasMoreData;

      } else if (this.app.isEmpty(window.campaignsIndexById)) {
        let message = 'No Records found';
        let description = 'You have no campaigns';
        if (this.apiResponse.error) {
          message = 'No instance connected';
          description = 'Please select an instance or contact help for support'
        }

        const noRecordsOptions = {
          title: message,
          class: 'available-mdcdot-table-height no-campaigns',
          description: description,
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };
        const placeholder = new NoRecordsPlaceholder(this.app, this.container.closest('.table-responsive'), noRecordsOptions);
        placeholder.render();
      }

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }

  }
}


(function (aimi_mdcdot_campaign, $, app, undefined) {
  // Private object
  let __this = {};

  aimi_mdcdot_campaign.campaignSettingsModal = async function (campaignData = {}, firstSequenceData = {}) {
    let campaign = {
      title: 'New Campaign',
      saveButtonText: 'Save Campaign',
      saveApi: 'mdcdot_campaign.save',
      mode: 'add',
      type: 'perpetual',
      isPublic: true,
      allowMultiple: true,
    }

    if (!app.isEmpty(campaignData) && !app.isEmpty(campaignData.id)) {
      campaign.id = campaignData.id;
      campaign.title = 'Edit Campaign';
      campaign.saveButtonText = 'Update Campaign';
      campaign.saveApi = 'mdcdot_campaign.update';
      campaign.mode = 'edit';
      campaign.public = campaignData.public;

      campaign.campaignName = campaignData.name;
      campaign.firstSequenceName = firstSequenceData.name;
      campaign.type = firstSequenceData.type;
      campaign.data = {};
    }

    const checkbox = _.template(app.templates['global__checkbox-switch']);
    const switchPublic = checkbox({
      'id': 'public',
      'name': 'public',
      'checked': campaign.public ? 'checked' : false,
      'value': true,
      'label': ' Make this campaign available in the campaign manager dropdown tool.'
    });
    const switchCampaignPermission = checkbox({
      'id': 'campaignPermission',
      'name': 'campaignPermission',
      'checked': 'checked',
      'value': 'allowedMultiple',
      'label': `Allow a contact to be added to this campaign multiple times.<div><small>(e.g., autoresponders or repeatable campaigns)</small></div>`
    });

    const switchDurationPerpetual = checkbox({
      'id': 'switchDurationPerpetual',
      'name': 'type',
      'type': 'radio',
      'checked': campaign.type === "perpetual" ? 'checked' : false,
      'value': 'perpetual',
      'label': `  Always Running`
    });

    const switchDurationOnTime = checkbox({
      'id': 'switchDurationOnTime',
      'name': 'type',
      'type': 'radio',
      'checked': campaign.type === "one-time" ? 'checked' : false,
      'value': 'one-time',
      'label': ` One Time`
    });

    app.inputPrompt({
      data: {
        ...campaign, ...{
          "campaignName": campaign.campaignName,
          "isPublic": campaign.isPublic,
          "allowMultiple": campaign.allowMultiple,
          "sequenceName": "Welcome Sequence",
          "switchPublic": switchPublic,
          "switchCampaignPermission": switchCampaignPermission,
          "switchDurationPerpetual": switchDurationPerpetual,
          "switchDurationOnTime": switchDurationOnTime
        }
      },
      type: "input",
      modalDialogClass: "modal-lg modal-dialog-centered modal-dialog-scrollable modal-new-campaign",
      template: 'dot_campaign__new',
      title: campaign.title,
      saveButtonText: campaign.saveButtonText,
      footerText: '<span class="fw-semibold text-primary">Note: Settings will get applied to all sequences</span>',
      saveApi: campaign.saveApi,
      payloadProcessor: 'aimi_mdcdot_campaign.campaignPayloadProcessor',
      saveApiCallBack: 'aimi_mdcdot_campaign.saveCallBack'
    }).then(function ($modal) {
      app.dotCampaignModal = $modal;

      if (!app.isEmpty(campaign.id)) {
        // Create the hidden input element
        const $hiddenInput = $('<input>', {
          type: 'hidden',
          name: 'campaignId',
          value: campaignData.id
        });

        // Append the hidden input to the $modal body
        $modal.find('form').append($hiddenInput);

      }

    });
  }

  aimi_mdcdot_campaign.saveCallBack = async function (response) {
    // Display a notification with the response message and set the progress to 90%
    app.notifyEl.update({'message': response.message, progress: 90});

    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

    console.log(response.sequence, !app.isEmpty(response.sequence));

    let url = `/email/campaign/${response.campaign.id}`;

    if (!app.isEmpty(response.sequence)) {
      url += `/${response.sequence.id}`;
    }

    app.redirect(url);
  };

  aimi_mdcdot_campaign.campaignPayloadProcessor = function (requestData) {
    requestData.filters = "CampaignManager";
    requestData.campaign = !app.isEmpty(requestData.id) ? requestData.id : requestData.campaignName;
    requestData.public = requestData.public === "true";
    requestData.campaignStart = "uponLaunch";
    return requestData;
  }

  aimi_mdcdot_campaign.list = {
    listRow: 'dot_campaign__row',

    buttons: function () {
      return {
        disable: function () {
          $(__this.containerRoot)
              .find('button:not([data-campaign-action="new-campaign"])')
              .attr('disabled', 'disabled');
        },
        enable: function () {
          $(__this.containerRoot).find('button').removeAttr('disabled');
        },
        disableRefresh: function () {
          $(__this.containerRoot).find('button[data-campaign-action="refresh-data"]').hide();
          const key = $('[data-item="campaignDataLastUpdatedOn"]');
          key.hide();
        },
        enableRefresh: function () {
          $(__this.containerRoot).find('button[data-campaign-action="refresh-data"]').show();
          const key = $('[data-item="campaignDataLastUpdatedOn"]');
          key.show();
        }
      }
    },
    init: function () {
      const self = this;
      const $listContainer = $('[data-campaigns]');
      __this.containerRoot = '.campaigns-container';
      const $parentContainer = $(__this.containerRoot);

      self.buttons().disable();

      // Add header columns
      const $headerContainer = $('[data-campaign-header]');

      _.each(MdcDotCampaign.types(), function (type) {
        const metrics = _.template(app.templates['dot_campaign__header-col']);
        const $metrics = $(metrics(type));
        $metrics.appendTo($headerContainer);
      });

      app.initTooltip();

      $parentContainer.find('.btn-sort').attr('disabled', 'disabled');

      __this.listMananger = new CampaignsList(app, $listContainer, self.listRow);
      __this.listMananger.onRenderList().then(function () {
        self.buttons().enable();
      });

      $(document).off('click.campaign-sort').on("click.campaign-sort", "[data-sort]", function (e) {
        const $this = $(this);
        let sortBy = $this.data('sort');
        let sortDirection = $this.attr('data-sort-direction');
        let $sortIcons = $('[data-sort] i');
        $sortIcons.removeClass('fa-arrow-down-short-wide fa-arrow-up-short-wide').addClass('fa-arrow-up-arrow-down');
        let $i = $this.find('i');
        if (sortDirection === 'ASC') {
          $i.addClass('fa-arrow-down-short-wide');
        } else {
          $i.addClass('fa-arrow-up-short-wide');
        }

        $this.attr('data-sort-direction', sortDirection === 'ASC' ? 'DESC' : 'ASC');
        __this.listMananger = new CampaignsList(app, $listContainer, self.listRow, sortBy, sortDirection);
        return false;
      });

      $(document).off('click.select-campaigns').on('click.select-campaigns', '[data-campaign-action]', async function (e) {
        const $this = $(this); // Cache the clicked element
        const action = $this.data('campaign-action'); // Extract the action from the data attribute

        // Reset UI states for mass actions and button styling
        MassActions.destroy();
        $('[data-campaign-action=select-all-campaigns], [data-campaign-action=select-all-campaigns-on-page], [data-campaign-action=deselect-all]')
            .attr('data-active', false)
            .removeClass('btn-primary text-white');

        // Use a switch statement to handle different actions
        switch (action) {
          case 'refresh-data':
            try {
              // Display loading state in the stats header and button
              MdcDotCampaign.statsHeaderLoader();
              app.button($this, 'loading');

              // Fetch campaign stats sequentially
              await __this.listMananger.fetchCampaignStatsSequentially();
            } catch (error) {
              // Log any errors during the fetch process
              console.error('Error fetching data:', error);
            } finally {
              // Reset the button state after operation
              app.doButtonResetDelayed($this, false);
            }
            break;

          case 'filter':
            // Apply campaign filtering logic
            const filter = new CampaignFilter();
            filter.filter();
            break;

          case 'campaign-sequence-lead':
            // Open a modal for campaign leads
            const $leadModal = app.infoModal('Campaign Leads', '', {
              id: 'campaignLeadModal',
              dialogClass: 'modal-dialog-scrollable modal-full modal-campaign-leads-library'
            });

            const $leadModalBody = $('.modal-body', $leadModal);

            // Render the leads template
            const leadTemplate = _.template(app.templates['dot_campaign__leads']);
            const $leadTemplate = $(leadTemplate());
            $leadTemplate.appendTo($leadModalBody);

            // Set lead search parameters and initialize leads list
            window['leadSearchParams'] = $this.data();
            aimi_mdcdot_leads.list.init('.campaign-leads-container');
            break;

          case 'campaign-sequence-email-variants':
            // Open a modal for email variants
            const $emailModal = app.infoModal('Email Variants', '', {
              id: 'emailVariantsModal',
              dialogClass: 'modal-dialog-scrollable modal-full modal-email-variants-library'
            });

            const $emailModalBody = $('.modal-body', $emailModal);

            // Render the email variants template
            const emailTemplate = _.template(app.templates['dot_email__list']);
            const $emailTemplate = $(emailTemplate());
            $emailTemplate.appendTo($emailModalBody);

            // Initialize email variants list
            aimi_mdcdot_email_variant.list.init('.email-variants-container');
            break;

          case 'new-campaign':
            aimi_mdcdot_campaign.campaignSettingsModal();
            break;

          default:
            // Log an unrecognized action for debugging purposes
            console.warn('Unrecognized action:', action);
            break;
        }
      });


      $(document).off('click.campaign_actions').on('click.campaign_actions', 'tr:not(.pre-loader) [data-campaign-rows-action]', function (e) {
        const $this = $(this);
        const action = $this.attr('data-campaign-rows-action');
        let id = $this.data('id');

        let title, description, $items = [];

        switch (action) {
          case 'delete' :

            let $item = $this.closest('tr[data-campaign]');
            let campaignId = $item.attr('data-campaign');
            let rowType = $item.attr('data-type');
            let requestData = {};

            if (rowType === 'campaign') {
              requestData = {campaignId: id};
              $items = $(`[data-campaign="${id}"]`);
              title = "Confirm Delete Campaign";
              description = "<div>Are you sure to delete this campaign? </div> <div> All sequences from this campaign will be removed and  all data will be lost </div>";
            } else if (rowType === 'sequence') {
              title = "Confirm Delete Sequence";
              description = "<div>Are you sure to delete this sequence? </div> <div> Your sequence will be removed and all data will be lost </div>";
              $items = $item;
              requestData = {
                campaignId: campaignId,
                sequenceId: id
              }
            }

            app.confirm(title, description).then(async function (response) {
              const $button = response.button;
              const confirm = response.confirm;
              const $modal = response.modal;

              // If the user confirms the deletion, proceed with the delete operation.
              if (confirm === true) {
                app.doButtonAction($button);
                let id = $this.data('id');

                app.apis.mdcdot_campaign.delete(requestData).done(function (response) {
                  if (response.success !== true) {
                    const message = response.message;
                    app.infoModal('Not Deleted', message);
                  } else {
                    $items.each(function (index, item) {
                      const $item = $(item);
                      app.removeItem($item, 'slideOutRight');
                    });
                  }
                  app.doButtonResetDelayed($button);
                  app.hideModal($modal);
                }).fail(function (response) {
                  app.doButtonReset($button, false);
                  app.hideModal($modal);
                });
              }
            });
            break;
          case 'launch' :
            title = "Confirm Campaign Launch";
            description = "<div>Are you sure you want to launch the campaign? </div> <div>Please make sure that all of the sequences are set up correctly, as we do not allow any changes to the campaign / sequences once the campaign is launched. Only available options will be to pause or delete the campaign.</div>";

            app.confirm(title, description).then(async function (response) {
              const $button = response.button;
              const confirm = response.confirm;
              const $modal = response.modal;

              // If the user confirms the deletion, proceed with the delete operation.
              if (confirm === true) {
                app.doButtonAction($button);

                app.apis.dot_instance_campaign.launch(id).done(function (response) {
                  app.doButtonResetDelayed($button);
                  app.hideModal($modal);
                  app.reload();
                }).fail(function (response) {
                  app.doButtonReset($button, false);
                  app.hideModal($modal);
                });
              }
            });

            break;

          case 'pause' :
            title = "Confirm Pause Campaign";
            description = "<div>Are you sure to pause this campaign? </div> <div> You can only pause the campaign, but we don't allow any changes to a campaign after launch </div>";

            app.confirm(title, description).then(async function (response) {
              const $button = response.button;
              const confirm = response.confirm;
              const $modal = response.modal;

              // If the user confirms the deletion, proceed with the delete operation.
              if (confirm === true) {
                app.doButtonAction($button);

                app.apis.dot_instance_campaign.pause(id).done(function (response) {
                  app.doButtonResetDelayed($button);
                  app.hideModal($modal);
                  app.reload();
                }).fail(function (response) {
                  app.doButtonReset($button, false);
                  app.hideModal($modal);
                });
              }
            });

            break;
        }

      });

      app.initSimpleBar($('#tab_block_1')[0]);

      // Event for instance switch
      $(document).off('submit.mdcdot_instance_user').on('submit.mdcdot_instance_user', 'form[name=mdcdot_instance_user]', function (e) {
        const $form = $(this);
      })

      $(document).off('change.mdcdot_instance_user').on('change.mdcdot_instance_user', 'form[name=mdcdot_instance_user] select', function (e) {
        const $form = $('form[name=mdcdot_instance_user]');
        $form.submit();
        return e.preventDefault();
      })


      const $chartContainer = $('.campaign-chart-container');
      __this.observerManager = new ImageObserverManager(app, '.campaign-chart', 'campaign-chart-width', $chartContainer);

      // To observe resizing for an element
      __this.observerManager.observeResize($chartContainer[0]);

      MdcDotCampaign.getHeaderColumn($headerContainer, $headerContainer);

      this.downnloadPdf();


    },

    downnloadPdf: function () {

      const getPdfName = function () {
        const instance = $('#instance').val();
        const userId = $('#user').val();

        return `${userId}-${instance}`;
      }

      document.getElementById("download").addEventListener("click", function () {
        const tabSection = document.querySelector('#tab_block_1');
        $(tabSection).addClass('pdf-preview');

        // Set PDF options
        let opt = {
          margin: 0.5,
          filename: getPdfName(),
          image: {type: 'jpeg', quality: 0.98},
          html2canvas: {scale: 2},
          jsPDF: {unit: 'in', format: [20, 30], orientation: 'portrait'}
        };

        setTimeout(function () {
          html2pdf().from(tabSection).set(opt).save().then(function () {
            $(tabSection).removeClass('pdf-preview');
          })
        }, 300);

      });

    }

  }
}(window.aimi_mdcdot_campaign = window.aimi_mdcdot_campaign || {}, jQuery, PreBuilt));


// Creating a map of class references
window["CampaignFilter"] = CampaignFilter;